module.exports = __webpack_public_path__ + "static/media/female-blue-v3.f61b3d82.svg";